module.exports = __webpack_public_path__ + "static/media/image2.c1dd05eb.jpg";